export default __webpack_public_path__ + "static/media/certificate-bg.d4796bc1.svg";